import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { SvbrgIntakeStatus } from '@/generated/gql/graphql';
import { IntakeStatusChip } from '~/components/IntakeStatusChip/IntakeStatusChip';

export type IntakeStatusChipCellValue = Union.Nullable<keyof typeof SvbrgIntakeStatus>;

interface IntakeStatusChipCellProps<R extends GridValidRowModel = any> {
  value: IntakeStatusChipCellValue;
  row: R;
}

export const IntakeStatusChipCell = <R extends GridValidRowModel = any>({ value }: IntakeStatusChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return value ? (
    <div>
      <IntakeStatusChip status={value} />
    </div>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
